import { newModel, StringAdapter } from "casbin";

export const model = newModel(`
[request_definition]
r = sub, obj, act

[policy_definition]
p = sub, obj, act, eft

[role_definition]
g = _, _

[policy_effect]
e = some(where (p.eft == allow)) && !some(where (p.eft == deny))

[matchers]
m = r.sub == p.sub && (p.obj == "*" || r.obj == p.obj) && regexMatch(r.act, p.act)
`);

export const adapter = new StringAdapter(`
p, administrator, *, (list)|(create)|(edit)|(delete)|(show)|(field), allow
p, moderator, *, (list)|(create)|(edit)|(delete)|(show)|(field), allow
p, moderator, users, (list)|(create)|(edit)|(delete)|(show)|(field), deny
p, reader, *, (list)|(show)|(field)|(edit), allow
p, reader, *, (create)|(delete), deny
p, reader, users, (list)|(create)|(edit)|(delete)|(show)|(field), deny
`)

export const normalizeRoleType = (role?: {
  type?: string;
  name?: string;
} | string | null) => {
  if (!role) return "";
  const type = typeof role === "string" ? role : role.type || "";
  const name = typeof role === "string" ? "" : role.name || "";
  const value = `${type} ${name}`.trim().toLowerCase();

  if (value === "administrator" || value === "admin") return "administrator";
  if (value === "moderator" || value === "administrative") return "moderator";
  if (
    value === "reader" ||
    value === "consulta" ||
    value === "lector"
  ) {
    return "reader";
  }

  return type.toLowerCase();
};
